import PropTypes from "prop-types";
import { ContentMenuLink } from "../Layout/templates";
import useGuidelinesModal from "../../hooks/modalHooks/useGuidelinesModal";
import GuidelinesMenuModal from "./GuidelinesMenuModal";

const GuidelinesMenuLink = ({ children, className = "", ...props }) => {
  return (
    <ContentMenuLink
      contentType="guidelines"
      className={className}
      useModalHook={useGuidelinesModal}
      menuModalComponent={GuidelinesMenuModal}
      {...props}
    >
      {children}
    </ContentMenuLink>
  );
};

GuidelinesMenuLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default GuidelinesMenuLink;
